module.exports = __webpack_public_path__ + "static/grey-wave-16dca91ca9845cf4d23e48acd2370ab3.svg";